export default __webpack_public_path__ + "static/media/Icon-Arrow_Blue.0ab9be65.svg";